	var $predictiveSearchStructure = "<div class='predictive-container'><div class='predictive-results'><ul class='courses unlist'></ul><ul class='articles unlist'></ul></div></div>";
	jQuery('.search-form').append($predictiveSearchStructure);

	arrowNavigation = function (e) {

		switch(e.which) {

			case 40: // key down, go to next item
				e.preventDefault();
				if(jQuery(this).hasClass("end-item")) {
					jQuery(".search-form input[data-search]").focus();
				}
				else if (jQuery(this).hasClass("end-course-item")) {
					// this is the last course item but not end item (there are article results), jump to start of articles list
					jQuery("ul.articles li a").first().focus();
				}
				else {
					jQuery(this).parent().next().find('a').focus();
				}


				// if last item but not end item, just to next list
				// if end item, return focus to search field or start item
			break;

			case 38: // key up, go to previous item
				e.preventDefault();
				if(jQuery(this).hasClass("start-item")) {
					jQuery(".search-form input[data-search]").focus();
				}
				else if (jQuery(this).hasClass("start-article-item")) {
					// this is the first article item but not start item (there are course results), jump to end of courses list
					jQuery("ul.courses li a").last().focus();
				}
				else {
					jQuery(this).parent().prev().find('a').focus();
				}

				// if first item but not start item, jump up to previous list
				// if start item, return focus to search field
			break;

			case 9: // tab, go to search submit button
				e.preventDefault();
				searchBar = jQuery(".search-bar-overlay");
				if(searchBar.length > 0) {
					// search bar is in play, shift focus to clear text button
					jQuery(".search-form .clearInput").focus();
				}
				else {
					jQuery(".search-form .submit").focus();
				}
			break;

			case 13: // enter, execute current item (this is default anyway?)

			break;

			case 27: // esc, go to search field

				jQuery(".search-form input[data-search]").focus();
				jQuery(".predictive-container").hide();
				jQuery(".search-form .form").removeClass("predictive-on");
			break;

			default:

			break;
		}
	};

	function get_hostname(url) {
		url = String(url);
	    var m = url.match("/^http.?:\/\/[^/]+/");
	    return m ? m[0] : null;
	}

	// Dont do a search for the same string, just show the box againif there were results
	var previousSearch = null;
	var previousResults = false;
	predictiveSearch = function(e){
		//console.log(jQuery(this).val());

		//console.log(previousSearch + " | " + jQuery(this).val());
		// if search is same as previous (search on focus), just show previous results without searching again. Don't show if there were no results.
		if (previousSearch == jQuery(this).val()) {
			if(previousResults == true) {
				jQuery(".predictive-container").show();
				jQuery(".search-form .form").addClass("predictive-on");
			}
			return;
		}

		jQuery(".predictive-container").hide();
		jQuery(".search-form .form").removeClass("predictive-on"); // hide the predictive container

		// only hit the service if there are at least 3 chars typed
		var searchString = jQuery(this).val();
		if(searchString.length > 2 && jQuery.type(searchString) === "string") {
			// over 3 chars, so lets hit the service and get us some results

			// set previous search so we dont repeat
			previousSearch = searchString;

			var result = jQuery.ajax({
				url: "/api/chisholmsearch/GetHomepageSearch/" + searchString,
				dataType: "json",
				success: function(data) {
					// successfully returned results
					//console.log("success!");
					//console.log(data);
					// console.log(data.Courses.length);

					predictiveContainer = jQuery(".predictive-container");
					courseResults = predictiveContainer.find("ul.courses");
					articleResults = predictiveContainer.find("ul.articles");

					hasCourseResults = false;
					hasArticleResults = false;

					if(data.Courses != null && data.Courses !== undefined && data.Courses.length > 0) {
						displayCourses = [];
						for (i = 0; i < data.Courses.length; i++) {
						    var CourseStream = data.Courses[i].CourseStream;
						    if (CourseStream !== undefined || CourseStream !== null || CourseStream.length > 0) {
						        CourseStream = "<span class='clean'>" + CourseStream + "</span>";
						    }							
							var CourseFreeTafeEligible = data.Courses[i].CourseFreeTafeEligible;
							if (CourseFreeTafeEligible !== undefined || CourseFreeTafeEligible !== null || CourseFreeTafeEligible.length > 0) {
								if(CourseFreeTafeEligible === true){					
									CourseFreeTafeEligible = "<img style='width: 20px;height: 20px;vertical-align: text-bottom;' class='icon' src='/img/Chisholm/fc-icon.svg' alt='Free TAFE Courses'>";
								}
								else{
									CourseFreeTafeEligible = "";
								}
							}	
						    displayCourses.push("<li><a href='" + data.Courses[i].CourseURL + "' title='Go to " + data.Courses[i].CourseTitle + "'>" + data.Courses[i].CourseTitle + CourseStream + CourseFreeTafeEligible + "</a></li>");
						}

						// show more results link
						if(data.CourseTotalResult > 3) {
							// we know the mobile show more needs to appear
							var moreLinkMobile = true;

							// check if desktop show more needs to appear as well
							if(data.CourseTotalResult > 5) {
								var moreLinkDesktop = true;
								var moreResultsDesktop = data.CourseTotalResult - 5;
								if (moreResultsDesktop > 1) {
									var moreLabelDesktop = "results";
								}
								else {
									var moreLabelDesktop = "result";
								}
							}

							var moreResultsMobile = data.CourseTotalResult - 3;
							if (moreResultsMobile > 1) {
								var moreLabelMobile = "results";
							}
							else {
								var moreLabelMobile = "result";
							}

							var moreLinks = "";
							if(moreLinkDesktop) {
								moreLinks += "<span class='show-for-medium-up'>Show " + moreResultsDesktop + " more " + moreLabelDesktop + "</span>";
							}

							if(moreLinkMobile) {
								moreLinks += "<span class='show-for-small-only'>Show " + moreResultsMobile + " more " + moreLabelMobile + "</span>";
							}


							displayCourses.push("<li class='more'><a href='/search?facets=fq=pagetypefilter_s:\"Course\"&searchStudioQuery=*" + encodeURIComponent(searchString) + "*' title=''>" + moreLinks + "</a></li>");

						}

						courseResults.html(displayCourses.join("\n"));
						courseResults.show();
						hasCourseResults = true;
					}
					else {
						courseResults.hide();
					}

					if(data.Articles != null && data.Articles !== undefined && data.Articles.length > 0) {
						displayArticles = [];
						for (i = 0; i < data.Articles.length; i++) {
							displayArticles.push("<li><a href='" +  data.Articles[i].ArticleURL + "' title='Go to " + data.Articles[i].ArticleTitle + "'>" + data.Articles[i].ArticleTitle + "</a></li>");
						}

						// show more results link
						if(data.ArticleTotalResult > 3) {
							// we know the mobile show more needs to appear
							var moreLinkArticlesMobile = true;
              				var moreLinkArticlesDesktop = false; // default to

							// check if desktop show more needs to appear as well
							if(data.ArticleTotalResult > 5) {
								var moreLinkArticlesDesktop = true;
								var moreResultsDesktop = data.ArticleTotalResult - 5;
								if (moreResultsDesktop > 1) {
									var moreLabelDesktop = "results";
								}
								else {
									var moreLabelDesktop = "result";
								}
							}

							var moreResultsMobile = data.ArticleTotalResult - 3;
							if (moreResultsMobile > 1) {
								var moreLabelMobile = "results";
							}
							else {
								var moreLabelMobile = "result";
							}

							var moreLinks = "";
							if(moreLinkArticlesDesktop) {
								moreLinks += "<span class='show-for-medium-up'>Show " + moreResultsDesktop + " more " + moreLabelDesktop + "</span>";
							}

							if(moreLinkArticlesMobile) {
								moreLinks += "<span class='show-for-small-only'>Show " + moreResultsMobile + " more " + moreLabelMobile + "</span>";
							}


							displayArticles.push("<li class='more'><a href='/search?searchStudioQuery=*" + encodeURIComponent(searchString) + "*' title=''>" + moreLinks + "</a></li>");
						}

						articleResults.html(displayArticles.join("\n"));
						articleResults.show();
						hasArticleResults = true;
					}
					else {
						articleResults.hide();
					}

					if(hasCourseResults || hasArticleResults) {
						previousResults = true; // let us know this search had results

						// set classes to determine start and end items for arrow navigation
						if(hasCourseResults) {

							// first item is very first
							jQuery(".predictive-container ul.courses li a").first().addClass("start-item");

							if(hasArticleResults) {
								jQuery(".predictive-container ul.articles li a").last().addClass("end-item");

								//last course should jump to first article
								// first article should jump up to last course

								// set start and end of course list
								jQuery(".predictive-container ul.courses li a").first().addClass("start-course-item");
								jQuery(".predictive-container ul.courses li a").last().addClass("end-course-item"); // should only need this

								// set start and end of articles list
								jQuery(".predictive-container ul.articles li a").first().addClass("start-article-item"); // should only need this
								jQuery(".predictive-container ul.articles li a").last().addClass("end-article-item");
							}
							else {
								jQuery(".predictive-container ul.courses li a").last().addClass("end-item");
							}
						}
						else if (hasArticleResults) {
							jQuery(".predictive-container ul.articles li a").first().addClass("start-item");
							jQuery(".predictive-container ul.articles li a").last().addClass("end-item");
						}


						jQuery(".predictive-container").show();
						jQuery(".search-form .form").addClass("predictive-on");

						// bind arrow navigation to new elements
						jQuery(".predictive-container li a").keydown(arrowNavigation);
					}


					// bindings for search overlay as it is all injected via js

					// bind the keydown function to the search field
					jQuery(".search-form input[data-search]").keydown(function(e) {
						// if the down arrow is pressed from input, we will send the user to the first item in the list
						if(e.which == 40) {
							e.preventDefault();
							firstVisibleItem = jQuery(".predictive-container ul:visible li a").first().focus();
						}
						else {
							return;
						}
					});

					// bind bypass predictive search results when tabbing from search submit (by hiding predictive results)
					jQuery(".search-form .quitSearch").focusin(function(e){
						jQuery(".predictive-container").hide();
						jQuery(".search-form .form").removeClass("predictive-on");
					}).keydown(function(e) {
						// handle tabbing from 'quit search' button
						if(e.which == 9) {
							e.preventDefault();
							jQuery(".icon.search a").first().focus();
						}
						else {
							return;
						}
					});

					return data;
				},
				error: function() {
					// there was a problem with the call or no results
					previousResults = false;
					console.log("No results returned");
				}
			});

		}
		else {
			// dont run ajax call
			return;
		}

	}

	// search predictive search
	//jQuery(".search-form input[data-search]").keyup(predictiveSearch);
	//jQuery(".search-form input[data-search]").focusin(predictiveSearch);
	const debouncePredictiveSearch = debounce(predictiveSearch,300,false);
	jQuery(".search-form input[data-search]").keyup(debouncePredictiveSearch);
	jQuery(".search-form input[data-search]").focusin(debouncePredictiveSearch);

	jQuery(".search-form input[data-search]").keydown(function(e) {
		// if the down arrow is pressed from input, we will send the user to the first item in the list
		if(e.which == 40) {
			e.preventDefault();
			firstVisibleItem = jQuery(".predictive-container ul:visible li a").first().focus();
		}
		else {
			return;
		}
	});

	// bypass predictive search results when tabbing from search submit (by hiding predictive results)
	jQuery(".search-form .submit").focusin(function(e){
		jQuery(".predictive-container").hide();
		jQuery(".search-form .form").removeClass("predictive-on");
	});

	/* DEPRECATED - we will just hide when the submit button is highlighted instead, as this is more logical
		jQuery(".search-form .submit").keydown(function(e) {
			// if tab is pressed from the submit button, jump passed any predictive results
			if(e.which == 9) {
				//e.preventDefault();
				jQuery(".predictive-container").hide();
				jQuery(".search-form .form").removeClass("predictive-on");
				//firstVisibleItem = jQuery(".predictive-container ul:visible li a").first().focus();
				//console.log(firstVisibleItem);
			}
			else {
				return;
			}
		});
	*/

	// hide when focus shifts outside of search form
	jQuery("body *").focusin(function() {
		var searchFocus = !! (jQuery(".search-form").find(':focus').length > 0);
		if(!searchFocus) {
			jQuery(".predictive-container").hide();
			jQuery(".search-form .form").removeClass("predictive-on");
		}
	});

	function debounce(func, interval) {
		var timeout;
		
		return function () {
		  var context = this, args = arguments;
		  var later = function () {
			timeout = null;
			func.apply(context, args);
		  };
		  clearTimeout(timeout);
		  timeout = setTimeout(later, interval || 200);
		}
	  }